<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      :clearable="clearable"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {TraderOfferGroup} from "@/modules/redactor/models/trader/TraderOfferGroup";

export default {
  name: "r-trader-offer-group",
  props: {
    model: VueTypes.instanceOf(TraderOfferGroup),
    label: VueTypes.string.def("Group"),
    clearable: VueTypes.bool.def(false)
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return TraderOfferGroup.getValues();
    }
  }
}

</script>